import { IconUserCircle } from '@tabler/icons-react';
import NSIcon from 'bricks/NSIcon/NSIcon';
import React, { useState } from 'react';
import { Dropdown, DropdownToggle } from 'reactstrap';
import { TOP_NAV_V2_ICON_PARENT_CLASS, TOP_NAV_V2_USER_ICON_CLASS } from 'components/NSNavBarV2/constants';
import { useTypedFlags } from 'hooks/useTypedFlags';
import UserMenuItems from './UserMenuItem/UserMenuItems';
import useGetAuthenticatedUser from '../../../../queries/UserMenu/useGetAuthenticatedUser';

const V1_USER_ICON_STYLE = { fontSize: '32px', width: '32px', height: '32px' };

const UserMenu: React.FC = () => {
    const { ldFlagNavbarV2 } = useTypedFlags();
    const { data: authenticatedUser } = useGetAuthenticatedUser();

    const [isUserMenuOpen, setIsUserMenuOpen] = useState<boolean>(false);
    const toggleUserMenu = () => setIsUserMenuOpen(!isUserMenuOpen);

    return (
        <Dropdown isOpen={isUserMenuOpen} toggle={toggleUserMenu} className="UserMenu-dropdown" data-testid="user-menu-dropdown">
            <DropdownToggle tag="span" data-testid="user-menu-toggle">
                <div
                    className={ldFlagNavbarV2 ? TOP_NAV_V2_ICON_PARENT_CLASS : undefined}
                    style={{ cursor: 'pointer' }}
                >
                    <NSIcon
                        icon={IconUserCircle}
                        className={ldFlagNavbarV2 ? `${TOP_NAV_V2_USER_ICON_CLASS} cursor--pointer` : 'cursor--pointer'}
                        style={ldFlagNavbarV2 ? undefined : V1_USER_ICON_STYLE}
                        aria-label="user menu"
                        data-testid="user-menu-icon"
                    />
                </div>
            </DropdownToggle>
            {isUserMenuOpen && <UserMenuItems authenticatedUser={authenticatedUser} />}
        </Dropdown>
    );
};

export default UserMenu;
